import { Space, Typography } from "antd";

import { FC } from "react";
import { useTheme } from "../../../../Styles/ThemeHook";
import { BathIcon } from "shared-components/Components/CustomIcons/BathIcon/web";
import { SinkIcon } from "shared-components/Components/CustomIcons/SinkIcon/web";

interface BathroomsTagProps {
	bathrooms: number;
	icon?: boolean;
	prefix?: boolean;
	isEspecial?: Boolean;
}

export const BathroomsTag: FC<BathroomsTagProps> = ({
	bathrooms,
	icon = false,
	prefix = false,
	isEspecial,
}) => {
	const { theme } = useTheme();

	return (
		<Space size={theme.spacing.smSpacing}>
			{isEspecial ? (
				<>
					{icon && <BathIcon className="icon" />}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							Baño{bathrooms!=1 ? 's':''}
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{prefix ? `+${bathrooms}` : bathrooms}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <SinkIcon style={{ color: theme.colors.textSecondaryColor }} />}
					<Typography.Text ellipsis>
						{prefix ? "+" : ""} {bathrooms} Baño{bathrooms!=1 ? 's':''}
					</Typography.Text>
				</>
			)}
		</Space>
	);
};
